export default __webpack_public_path__ + "8281fd4348839ba5670590392304323b.svg";